<script>
import CommonTableComponent from "@/components/table.vue";
import number from "@/mixins/number";
import tableSearch from "@/mixins/tableSearch";
import DatePicker from "vue2-datepicker";
import dailyReportControlRules from "@/mixins/dailyReportControlRules";

export default {
  name: "CarsInput",
  components: {
    CommonTableComponent,
    DatePicker,
  },
  mixins: [number, tableSearch],
  props: {
    dailyReport: {
      type: Object,
      required: true,
    },
    carsByWorkOrder: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Object,
      default: () => {},
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    controlRules: {
      type: Object|null,
    },
    isApproveSidePage: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getZzUnit(estimate) {
      return estimate.zz_unit?.unit;
    },
    getZzUnitBGColorClass(estimate) {
      return (estimate.zz_unit.id != '11');
    },
    isDisplaied(item){
      if(item.type == "all") return true;
      if(item.type == "approve" && this.isApproveSidePage) return true;
      return false;
    },
    getUnitPrice(estimate){
      return estimate.unit_price;
    },
    getIsApproveSidePage(){
      return this.isApproveSidePage;
    },
  },
  computed: {
    estimateHeaders() {
      return [
        {
          text: "見積明細番号",
          value: "estimate_cd",
          type: "all",
          sortable: false,
          additionalClasses: "estimate_cd"
        },
        {
          text: "請求書表示用商品名",
          value: "product_name",
          type: "all",
          sortable: false,
          additionalClasses: "product_name"
        },
        {
          text: "数量",
          value: "quantity",
          type: "all",
          sortable: false,
          additionalClasses: "quantity"
        },
        {
          text: "単位",
          value: "unit",
          type: "all",
          sortable: false,
          additionalClasses: "unit"
        },
        {
          text: "単価",
          value: "unit_price",
          sortable: false,
          type: "approve",
          additionalClasses: "unit_price"
        },
      ];
    },
  }
}
</script>

<template>
  <b-card>
    <b-row class="mt-2">
      <div class="custom-table gap-2">
        <div class="title">見積明細</div>
        <CommonTableComponent class="table-custom" :height-class="`table-wrapper-500`">
          <thead class="table-light">
          <tr>
            <template
              v-for="(item, index) in estimateHeaders">
              <th
                v-if="isDisplaied(item)"
                :class="getHeaderClass(item)"
              >
                <span>
                {{ item.text }}
                </span>
              </th>
            </template>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(estimate, estimateIndex) in carsByWorkOrder"
            :key="`estimate_${estimate.id}`"
          >
            <td>{{ estimate.estimate_cd }}</td>
            <td>{{ estimate.invoice_product_name }}</td>
            <td>
              <b-form-input
                @keyup="setMinNumber($event)"
                type="number"
                v-model="estimate.number_of_cars"
                min="0"
              ></b-form-input>
              <div
                v-if="errors[`cars_by_daily_report.${estimateIndex}.number_of_cars`]"
                class="error-message"
              >
                {{errors[`cars_by_daily_report.${estimateIndex}.number_of_cars`][0] }}
              </div>
            </td>
            <td :class="{bg_notice:getZzUnitBGColorClass(estimate)}">
              {{getZzUnit(estimate)}}
            </td>
            <td v-if="getIsApproveSidePage()">
              {{getUnitPrice(estimate)}}
            </td>
          </tr>
          <tr v-if="!carsByWorkOrder.length && !isLoading">
              <td colspan="6" class="text-center">
                  データなし。
              </td>
          </tr>
          </tbody>
        </CommonTableComponent>
      </div>
    </b-row>
  </b-card>
</template>
<style lang="scss" scoped>
.estimate_cd{
  width:10%;
  min-width:100px;
}

.product_name{

}
        
.quantity{
  width:15%;
  min-width:100px;
}

.unit{
  width:10%;
  min-width:50px;

}
.unit_price{
  width:10%;
  min-width:70px;
}

.bg_notice{
  background-color: yellow;
}

</style>